module.exports = __webpack_public_path__ + "robots.txt";


//////////////////
// WEBPACK FOOTER
// ./src/static/robots.txt
// module id = 19
// module chunks = 0